/* template */
<template minapp="mpx" xlang="wxml"><div class="mpx-root-view"><div><div :id="(trainConf.keyTitle)" :style='[("height:"+(windowHeight)+"px")] | transRpxStyle'><es-layout :leftArrow="(true)" :navbarClickLeft="(goback)" navbarTitle="我的行程" custom-class="my-class" :navbarStyle="(navbarStyle)" :loadingImageUrl="(loadingImg)" :blankPageType="(blankPageType)" :useBlankPage="(pageFailed)" :useDefaultNavbar="(!pageFailed)" @scrolltobottom="onScrollToBottom" @blank-retry="fetchOrderList(trainConf)" :scrollTop="(trainConf.pageScrollHeight)"><div class="order-tip" v-if="(isShowEmpty)"><login-card :customStyle="(emptyCustomStyle)" v-if="(needMandatoryLogin)"/><mpx-image src="https://pt-starimg.didistatic.com/static/starimg/img/8jPyrnQfol1642402065727.png" class="null-image"/><div class="null-title">暂无{{ trainConf.name }}行程</div><div class="null-context">当前暂无{{ trainConf.name }}行程记录</div><mpx-view @tap="logout" class="log-out" v-if="(showLogout)"><div class="log-out-btn">退出登录</div></mpx-view></div><mpx-view @touchend="touchEnd" @touchmove="touchMove" @touchstart="touchStart" @tap="handClick" class="card-main" v-else><div :style='[("transform:"+(transformY)+";")] | transRpxStyle' class="card-main-pull"><mpx-image :src="(loadingIcon)" class="pulldown-loading"/><div class="pulldown-text">松开立即刷新</div></div><div :style='[("transform:"+(transformY)+";")] | transRpxStyle' class="card-container"><login-card :customStyle="(customStyle)" v-if="(needMandatoryLogin)"/><div v-for="(titleItem, index) in (trainConf.allData)" :key="titleItem['{{index}}']"><div class="title" v-if="(titleItem.isMust && titleItem.data.length)">{{ titleItem.title }}</div><div v-for="(orderItem, index) in (titleItem.data)" :key="orderItem.order_id" class="card-mtop"><es-card-del :index="(index)" :item="({ orderItem, index, titleItem })" @click-right="delData" @click-left="goDetail" v-if="(!orderItem.union_journey)"><div slot="mainContext" class="main-context"><component :is="(trainConf.component)" :item="(orderItem)"></component></div><div slot="delContext" class="del-box"><div>删除</div></div></es-card-del><transfer-train-order-card :orderItem="(orderItem)" :orderIndex="(index)" :titleItem="(titleItem)" @delData="delData" @goDetail="goDetail" v-else/></div></div></div><div class="order-loading">{{ loadingText }}</div><mpx-view @tap="logout" class="log-out" v-if="(showLogout)"><div class="log-out-btn">退出登录</div></mpx-view></mpx-view></es-layout></div></div><es-dialog showCancelButton showConfirmButton title="温馨提示" :show="(show)" :algin="(algin)" @cancel="onCancel" @confirm="onConfirm"><div slot="content">{{ dialogText }}</div></es-dialog></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m889b8056"}'>
  .log-out
    margin: 20px 0;
    border: 1px solid #CCCCCC;
    border-radius: 8px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    .log-out-btn
      color #666
  .my-class
    height 100%
    font-family PingFangSC-Regular
  .order-loading
    height 40px
    width 100%
    text-align center
    line-height 40px
    font-size 14px
    color #666
  .navbar
    z-index 100
  .order-tip
    text-align center
    font-weight 400
    height 100%
    background #F3F4F5
  .null-image
    height 100px
    width 100px
    margin-top 172px
  .null-title
    color #333
    font-size 14px
    margin 16px 0 2px 0
    height 20px
    ling-height 20px
  .null-context
    color #999
    font-size 12px
  .card-main
    margin 0 12px
    transform translateY(-40px)
    min-height calc(100% + 1px)
  .card-container
    flex 1
  .title
    padding-top 8px
    font-size 14px
    color #999
  .card-mtop
    padding-top 10px
  .del-box
    display flex
    justify-content flex-end
    align-items center
    border-radius 9px
    font-size 14px
    font-weight 500
    font-family PingFangSC-Regular
    height 100%
    background #F93822
    padding-right 24px
  .pulldown-text
    color #666
    font-size 14px
    padding-right 28px
  .card-main-pull
    display flex
    justify-content center
    align-items center
    width 100%
    height 40px
  .pulldown-loading
    width 20px
    height 20px
    margin-right 12px
    animation spin 2s linear infinite
  @keyframes spin
    0%
      transform rotate(0deg)
    100%
      transform rotate(360deg)
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m889b8056"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m889b8056"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {"onReachBottomDistance":0},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-dialog':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/dialog/index.mpx?isComponent&outputPath=components%2Findex3651661c%2Findex")),'train-card':getComponent(require("./components/newTrainOrderCard.mpx?isComponent&outputPath=components%2FnewTrainOrderCardb25b7030%2Findex")),'transfer-train-order-card':getComponent(require("./components/transfer-train-order-card.mpx?isComponent&outputPath=components%2Ftransfer-train-order-card50e2b4f0%2Findex")),'tickets12306-entrance':getComponent(require("./components/tickets12306-entrance.mpx?isComponent&outputPath=components%2Ftickets12306-entrance921da7b8%2Findex")),'es-card-del':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/card-del/index.mpx?isComponent&outputPath=components%2Findex1fb7d810%2Findex")),'login-card':getComponent(require("../../components/login-card.mpx?isComponent&outputPath=components%2Flogin-card99f1ea5e%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
